export const travelRequestHeaders = {
  RequestNo: 'Request No',
  TravelDate: 'Date',
  TravelDestination: 'Destination',
  TravelPurpouse: 'Purpose',
  Status: 'Status',
};

export const renderStatusColors = {
  New: {
    backgroundColor: '#EFF8FF',
    fontColor: '#175CD3',
    borderColor: '#B2DDFF',
    dotColor: '#2E90FA',
  },
  'Request for Quotation': {
    backgroundColor: '#F0F9FF',
    fontColor: '#026AA2',
    borderColor: '#BAE6FD',
    dotColor: '#0DA6EA',
  },
  'Pending for Decision': {
    backgroundColor: '#FF98001A',
    fontColor: '#B54708',
    borderColor: '#FF9800',
    dotColor: '#B54708',
  },
  'Pending for Submission': {
    backgroundColor: '#EEF4FF',
    fontColor: '#3538CD',
    borderColor: '#C7D7FE',
    dotColor: '#6172F3',
  },
  'Pending for Approval': {
    backgroundColor: '#F0FDF9',
    fontColor: '#107569',
    borderColor: '#99F6E0',
    dotColor: '#15B79E',
  },
  'Awaiting HR Approval': {
    backgroundColor: '#F5FBEE',
    fontColor: '#3F621A',
    borderColor: '#CEEAB0',
    dotColor: '#669F2A',
  },
  'Pending for Booking': {
    backgroundColor: '#F4F3FF',
    fontColor: '#5925DC',
    borderColor: '#D9D6FE',
    dotColor: '#7A5AF8',
  },
  'Booking Confirmed': {
    backgroundColor: '#ECFDF3',
    fontColor: '#067647',
    borderColor: '#ABEFC6',
    dotColor: '#17B26A',
  },
  'Booking Cancelled': {
    backgroundColor: '#FEF3F2',
    fontColor: '#B42318',
    borderColor: '#FECDCA',
    dotColor: '#F04438',
  },
  'Request for Rebooking': {
    backgroundColor: '#F8F9FC',
    fontColor: '#363F72',
    borderColor: '#D5D9EB',
    dotColor: '#4E5BA6',
  },
  'Request for Cancellation': {
    backgroundColor: '#FDF2FA',
    borderColor: '#FCCEEE',
    fontColor: '#C11574',
    dotColor: '#EE46BC',
  },
  Rejected: {
    backgroundColor: '#FFF1F3',
    fontColor: '#C01048',
    borderColor: '#FECDD6',
    dotColor: '#F63D68',
  },
  'Travel Cancelled': {
    backgroundColor: '#FEFBE8',
    fontColor: '#A15C07',
    borderColor: '#FEEE95',
    dotColor: '#EAAA08',
  },
};
